export const BASE_URL = "https://stageaffiliateadminapi.shubhraviraj.in/Affiliates/"; // replace with your main API base
export const BASE_URL2 = "https://nodesrapi.shubhraranjan.com/api/v1/client/"; // replace with your main API base
 export const AuthToken='51Ln8wxFBY4E5vssUUDS1W93K71pOoc9DIoudY1no17ZClSD89';
 export const AuthToken2='qaw8AxBFDXzJLbhMJyTOmkoFGLlagVUY';
